import { message } from "antd";
import { Result } from "../helper/result";
import { validate, ValidationError } from "class-validator";

export class ValidationModel {
  valid = async <T>(): Promise<Result<string, T>> => {
    const errors: ValidationError[] = await validate(this, {
      skipMissingProperties: false,
      whitelist: false,
      forbidNonWhitelisted: true,
    });

    if (errors.isNotEmpty()) {
      const flatten = (items: ValidationError[], prefix = ""): string[] => items.flatMap(error => {
        const path = prefix ? `${prefix}.${error.property}` : error.property;
        return [...Object.values(error.constraints || {}).map(text => `${path}: ${text}`),
          ...flatten(error.children || [], path)];
      });
      return Result.error(flatten(errors).join("; "));
    } else {
      return Result.ok(this as unknown as T);
    }
  };
  validMessage = async<T>(): Promise<Result<string, T>> => {
    const result = await this.valid<T>();
    if (result.isFailure()) {
      message.error(result.error);
    }
    return result;
  }
}
